import Typography from '@mui/material/Typography';
import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { Translation, useNavigate } from '@ps/web-shared-components';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import useWizardExit from '@swf/core/hooks/useWizardExit';
import { type Dispatch, select } from '@swf/core/store';

import CTAButton from '../../CTAButton/CTAButton';
import Prompt from '../../Prompt/Prompt';
import TempAccountLimit from '../../Prompts/TempAccountLimit/TempAccountLimit';

import {
  TXTCLI_Logout,
  TXTWCL_AlternativelyX_if_your_details_ELL,
  TXTWCL_Online_Validation_Unsuccessful,
  TXTWCL_Verify_my_account
} from './ValidationUnsuccessful.messages.json';
import { button } from './ValidationUnsuccessful.scss';

interface Props {
  onClose(): void;
}

const ValidationUnsuccessful: React.FC<Props> = ({ onClose }) => {
  const [showVerificationPrompt, setShowVerificationPrompt] = useState(false);
  const exitWizard = useWizardExit();
  const { auth } = useDispatch<Dispatch>();
  const navigate = useNavigate();
  const { redirectTo } = useSelector(select.localSettings.get);
  const isEmbedded = useSelector(select.device.isEmbedded);
  const verifyDoc = useFeature(FeatureFlag.VerifyDoc);

  const openVerificationPrompt = () => {
    isEmbedded && verifyDoc
      ? window.starsweb?.app?.execute('docverify')
      : setShowVerificationPrompt(true);
  };

  const handleLogout = () => {
    redirectTo ? navigate(redirectTo) : exitWizard();
    auth.logout();
    onClose();
  };

  const handleVerificationClose = () => {
    setShowVerificationPrompt(false);
    onClose();
  };

  return (
    <Prompt
      onClose={onClose}
      noCloseButton
      variant="default"
      title={{ translation: TXTWCL_Online_Validation_Unsuccessful }}
    >
      <Typography>
        <Translation {...TXTWCL_AlternativelyX_if_your_details_ELL} />
      </Typography>
      <CTAButton
        className={button}
        translation={TXTWCL_Verify_my_account}
        onClick={openVerificationPrompt}
      />
      <CTAButton
        className={button}
        variant="secondary"
        translation={TXTCLI_Logout}
        onClick={handleLogout}
      />

      {showVerificationPrompt && <TempAccountLimit onClose={handleVerificationClose} />}
    </Prompt>
  );
};

export default ValidationUnsuccessful;
